<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="2"
        class="pb-0"
      >
        <v-select
          v-model="filterStatusId"
          :items="statuses"
          item-text="name"
          item-value="id"
          label="Status"
          clearable
        >
          <template #item="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
          <!-- eslint-disable-next-line vue/no-template-shadow -->
          <template #selection="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
        </v-select>
      </v-col>
      <v-col
        cols="2"
        class="pb-0"
      >
        <v-menu
          ref="menuDate"
          v-model="dateMenu"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="filterDate"
              label="Date"
              readonly
              v-bind="attrs"
              append-icon="mdi-calendar"
              v-on="on"
              @change="$refs.menuDate.save(filterDate)"
            />
          </template>
          <v-date-picker
            v-model="filterDate"
            no-title
            scrollable
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="menu = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="filterDate = null"
            >
              Clear
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="2"
        class="pb-0"
      >
        <v-autocomplete
          v-model="filterUserId"
          label="User"
          :items="users"
          :item-text="(user) => `${user.first_name} ${user.last_name}`"
          item-value="id"
          clearable
        />
      </v-col>
      <v-spacer />
      <v-col
        cols="auto"
        class="mt-4 pb-0"
      >
        <v-btn
          color="primary"
          outlined
          @click="open"
        >
          <v-icon
            small
            class="mr-1"
          >
            fas fa-plus
          </v-icon>
          New Bundle
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="footer"
            :items-per-page="pagination.itemsPerPage"
            :search="search"
            :loading="loading"
            dense
            :height="tableHeight"
            :server-items-length="total"
            @pagination="updatePagination"
          >
            <template #[`item.bundle_number`]="{ item }">
              <text-highlight :queries="search">
                {{ item.bundle_number ? item.bundle_number : '' }}
              </text-highlight>
            </template>
            <template #[`item.skid_number`]="{ item }">
              <text-highlight :queries="search">
                {{ item.commercial_skid_item && item.commercial_skid_item.commercial_skid ? item.commercial_skid_item.commercial_skid.skid_number : '' }}
              </text-highlight>
            </template>
            <template #[`item.bol_number`]="{ item }">
              <text-highlight :queries="search">
                {{ item.bol_number ? item.bol_number : '' }}
              </text-highlight>
            </template>
            <template #[`item.job`]="{ item }">
              <span>
                <span style="font-weight: bold;"><text-highlight :queries="search">{{ item.job_code ? `${item.job_code}` : '' }}</text-highlight></span><text-highlight :queries="search"> - {{ item.job_name ? item.job_name : '' }}</text-highlight> <span style="color: #1976D2;"><text-highlight :queries="search">{{ item.job_reference ? `; ${item.job_reference}` : '' }}</text-highlight></span>
              </span>
            </template>
            <template #[`item.quantity`]="{ item }">
              <text-highlight :queries="search">
                {{ item.total_item_qty ? item.total_item_qty : '0' }}
              </text-highlight>
            </template>
            <template #[`item.created`]="{ item }">
              <text-highlight
                style="font-weight: 500;"
                :queries="search"
              >
                {{ item.created_by_full_name ? item.created_by_full_name : '' }}
              </text-highlight>
              <text-highlight
                :queries="search"
              >
                {{ item.created_at ? item.created_at : '' }}
              </text-highlight>
            </template>
            <template #[`item.shipped`]="{ item }">
              <text-highlight
                style="font-weight: 500;"
                :queries="search"
              >
                {{ item.shipped_by_full_name ? item.shipped_by_full_name : '' }}
              </text-highlight>
              <text-highlight
                :queries="search"
              >
                {{ item.shipped_at ? item.shipped_at : '' }}
              </text-highlight>
            </template>
            <template #[`item.received`]="{ item }">
              <text-highlight
                style="font-weight: 500;"
                :queries="search"
              >
                {{ item.received_by_full_name ? item.received_by_full_name : '' }}
              </text-highlight>
              <text-highlight
                :queries="search"
              >
                {{ item.received_at ? item.received_at : '' }}
              </text-highlight>
            </template>
            <template #[`item.status`]="{ item }">
              <v-chip
                small
                :color="item && item.status ? item.status.color : ''"
                text-color="white"
              >
                <text-highlight :queries="search">
                  {{ item && item.status ? item.status.name : '' }}
                </text-highlight>
              </v-chip>
            </template>
            <template
              #[`item.actions`]="{ item }"
            >
              <v-btn
                v-if="item.status_id === commercialBundleStatusIdNew"
                class="ml-1 mt-1 mb-1 mr-1"
                color="warning"
                outlined
                small
                @click="edit(item)"
              >
                EDIT
              </v-btn>
              <v-btn
                v-else
                class="ml-1 mt-1 mb-1 mr-1"
                color="primary"
                outlined
                small
                @click="view(item)"
              >
                VIEW
              </v-btn>
              <!-- <v-btn
                class="ml-1 mt-1 mb-1 mr-1"
                color="success"
                outlined
                small
                @click="runWebhook(item)"
              >
                PDF
              </v-btn> -->
              <v-menu offset-y>
                <template #activator="{ on, attrs }">
                  <v-btn
                    class="mt-1 mb-1"
                    elevation="0"
                    fab
                    outlined
                    x-small
                    v-bind="attrs"
                    tile
                    color="primary"
                    style="border-radius: 7px; width: 28px !important; height: 28px !important;"
                    v-on="on"
                  >
                    <v-icon>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </template>
                <v-list
                  class="pa-3"
                >
                  <v-list-item
                    @click="runWebhook(item)"
                  >
                    <v-list-item-title :style="`color: green; font-weight: 600;`">
                      <v-row align="center">
                        <v-col
                          cols="auto"
                          class="pr-0"
                          style="white-space: nowrap;"
                        />
                        <v-col class="pt-4">
                          PDF
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="softDelete(item)"
                  >
                    <v-list-item-title :style="`color: red; font-weight: 600;`">
                      <v-row align="center">
                        <v-col
                          cols="auto"
                          class="pr-0"
                          style="white-space: nowrap;"
                        />
                        <v-col class="pt-4">
                          DELETE
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <commercial-bundle-form
      ref="commercialBundleForm"
      @success="success"
    />
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CommercialBundleForm from '@/components/forms/commercialBundles/CommercialBundleForm';
import { saveAs } from 'file-saver';
import * as FormatHelpers from '@/helpers/FormatHelpers';

export default {
  components: {
    CommercialBundleForm,
  },
  props: {

  },
  data: () => ({
    items: [],
    statuses: [],
    users: [],
    footer: {
      'items-per-page-options': [20, 100, 500, 1000, -1],
    },
    loading: false,
    total: 0,
    pagination: {
      itemsPerPage: 20,
      page: 1,
    },
    headers: [
      { text: 'Bundle#', value: 'bundle_number', width: '5%' },
      { text: 'Job Ref', value: 'job', width: '20%' },
      { text: 'Qty', value: 'quantity', width: '3%' },
      { text: 'Skid#', value: 'skid_number', width: '5%' },
      { text: 'Bill Of Lading#', value: 'bol_number', width: '5%' },
      {
        text: 'Status', value: 'status', align: 'center', width: '6%',
      },
      { text: 'Created', value: 'created', align: 'center', width: '16%' },
      { text: 'Shipped', value: 'shipped', align: 'center', width: '16%' },
      { text: 'Received', value: 'received', align: 'center', width: '16%' },
      { text: 'Actions', value: 'actions', align: 'end', width: '10%' },
    ],

    topSpaceHeight: 310,
    tableHeight: 1000,

    roles: [],
    userRoleIdAdmin: 3,
    userRoleIdCommercialScheduleAdmin: 41,
    userRoleIdCommercialScheduleSupervisor: 42,

    commercialBundleStatusIdNew: 1,

    dateMenu: false,
    filterStatusId: null,
    filterDate: null,
    filterUserId: null,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
      user: (state) => state.user,
    }),
    ...mapGetters([

    ]),
    isAdmin() {
      return this.roles.includes(this.userRoleIdAdmin);
    },
    isCommercialScheduleAdmin() {
      return this.roles.includes(this.userRoleIdCommercialScheduleAdmin);
    },
    isCommercialScheduleSupervisor() {
      return this.roles.includes(this.userRoleIdCommercialScheduleSupervisor);
    }, 
  },
  watch: {
    search() {
      this.get();
    },
    filterStatusId() {
      this.get();
    },
    filterDate() {
      this.get();
    },
    filterUserId() {
      this.get();
    },
    pagination() {
      this.get();
    },
  },
  created() {
    this.roles = this.user.roles.map((x) => x.id);
    this.init();
    window.scrollTo(0, document.body.scrollHeight);
    this.tableHeight = window.innerHeight - this.topSpaceHeight;
  },
  methods: {
    init() {
      this.get();
      this.getStatuses();
      this.getUsers();
    },

    async get() {
      this.loading = true;
      this.items = [];
      this.total = 0;
      const submitModel = {
        filters: {
          status_id: this.filterStatusId,
          date: this.filterDate,
          user_id: this.filterUserId,
        },
        search: this.search,
        pagination: this.pagination,
      };
      const res = await this.$api.commercialBundle.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data) {
        this.items = [];
        this.loading = false;
        return;
      }
      this.items = res.data;
      this.total = res.total;
      this.loading = false;
    },

    open() {
      this.$refs.commercialBundleForm.open();
    },

    view(item) {
       const isViewing = true;
      this.$refs.commercialBundleForm.open(item.id, isViewing);
    },

    edit(item) {
      this.$refs.commercialBundleForm.open(item.id);
    },

    async softDelete(item) {
      if (item.shipped_at || item.received_at) {
        this.$bus.$emit('showError', 'This record cannot be deleted as it has already been shipped or received.');
        return;
      }
      if (item.bill_of_lading) {
        const billOfLadingCode = item.bol_number ? `Bill of Lading #${item.bol_number}` : '';
        const confirm = await this.$refs.confirmForm.open({
          title: `This bundle belongs to the pending ${billOfLadingCode}. Are you sure you want to delete it?`,
        });
        if (!confirm) return;
      } 
      else if (item.commercial_skid_item && item.commercial_skid_item.commercial_skid) {
        const skidCode = item.commercial_skid_item.commercial_skid.skid_number ? `Skid #${item.commercial_skid_item.commercial_skid.skid_number}` : '';
        const confirm = await this.$refs.confirmForm.open({
          title: `This bundle belongs to ${skidCode}. Are you sure you want to delete it?`,
        });
        if (!confirm) return;
      }
      else {
        const confirm = await this.$refs.confirmForm.open({
          title: 'Are you sure that you want to delete this record?',
        });
        if (!confirm) return;
      }
      if (!item.id) return;
      this.$bus.$emit('loading');
      const res = await this.$api.commercialBundle.delete(item.id);

      if (!res) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('loading');
      this.$bus.$emit('showSuccess');
      this.get();
    },

    updatePagination(pagination) {
      if (pagination.page !== this.pagination.page || pagination.itemsPerPage !== this.pagination.itemsPerPage) { this.pagination = pagination; }
    },

    success() {
      this.get();
    },

    async getStatuses() {
      this.statuses = [];
      const res = await this.$api.commercialBundleStatus.get();
      if (!res) {
        this.statuses = [];
        return;
      }
      this.statuses = res;
    },

    async getUsers() {
      this.users = [];
      const res = await this.$api.user.get();
      this.users = res;
    },

    async runWebhook(item) {
      this.$bus.$emit('loading');
      const webhookModuleIdCommercialBundle = 69;
      const webhookData = {
        module_id: webhookModuleIdCommercialBundle,
        bundle_number: item.bundle_number,
      };

      const res = await this.$api.webhook.store(webhookData, 'run-download', { responseType: 'blob' });
      if (!res) {
        this.$bus.$emit('showError');
        this.$bus.$emit('loading');
        return;
      }

      const now = FormatHelpers.getFileTimestamp();
      const fileName = `${item.bundle_number}_${now}`;

      const file = new Blob([res], {
        type: 'application/pdf',
      });
      saveAs(file, fileName);
      this.$bus.$emit('loading');
    },

  },
};
</script>

<style scoped>
span
{
  font-size: 12px !important;
}
</style>
